import { render, staticRenderFns } from "./NumeratoriListComponent.vue?vue&type=template&id=b653bc50"
import script from "./NumeratoriListComponent.vue?vue&type=script&lang=js"
export * from "./NumeratoriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports